import styled, { css } from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const StyledToggleButton = styled.button<{
  inverted: boolean;
  isLeftAligned: boolean;
  isSelected: boolean;
  isSmall: boolean;
  setWidth: number;
  isDisplayed: boolean;
  disabled: boolean;
}>`
  display: ${({ isDisplayed }) => (isDisplayed ? 'flex' : 'none')};
  padding-left: 20px;
  padding-right: 20px;
  height: 46px;
  align-items: center;
  border-radius: 4px;
  justify-content: ${({ isLeftAligned }) => (isLeftAligned ? 'start' : 'center ')};
  font-size: 13px;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  line-height: 19px;
  text-decoration: none;
  outline: none;
  border: 1px solid ${({ theme }) => theme.customColors.primary};
  width: ${({ setWidth }) => (setWidth ? `${setWidth}px` : 'initial')};

  &[disabled] {
    opacity: 0.4;
    cursor: auto;
    background: #fff;
  }

  ${({ isSelected, theme, inverted, disabled }) => {
    const primaryColor = theme.customColors.primary;
    const white = 'white';

    const background = isSelected ? primaryColor : white;
    const foreground = isSelected ? white : primaryColor;

    return css`
      color: ${inverted ? background : foreground};
      background: ${inverted ? foreground : background};
      ${disabled &&
      inverted &&
      `
        background: grey!important;
        border-color: grey;
      `}
    `;
  }}

  ${({ isSmall }) =>
    isSmall &&
    css`
      height: 36px;
    `};

  ${media.sm`
    font-size: 14px;
  `}
`;
